export const API_SUCCESS_MESSAGE = "保存しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー";
export const DEFAULT_TIMER = 1000;
export const MAX_INTEGER = 2147483646;
export const MAX_TEXT_LENGTH = 255;
export const PASSWORD_CHANGE_SUCCESS_MESSAGE = "パスワードが再設定されました。";
export const DATA_CONFLICT_MESSAGE = "{{name}}が他の操作によって更新されています。\nリロードして最新情報を取得してください。";
